import React, {useEffect, useState} from 'react';
import {DictItemDto} from "../../../../../../modules/dict/dto/DictItemDto";
import {RequestVisitorDto} from "../../../../../../modules/vms/dto/RequestVisitorDto";
import {useIntl} from "react-intl";
import {DictClassCode} from "../../../../../../modules/vms/constants/DictClassCode";
import {DictClassApi} from "../../../../../../modules/dict/api/DictClassApi";
import {HttpStatus} from "../../../../../../modules/common/enums/HttpStatus";
import {ValidateUtils} from "../../../../../../utils/ValidateUtils";
import {Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton} from "@mui/material";
import CancelButton from "../../../../../../components/buttons/CancelButton";
import SaveButton from "../../../../../../components/buttons/SaveButton";
import FormFieldDictItems from "../../../../../dict/components/FormFieldDictItems";
import FormFieldText from "../../../../../../components/FormFieldText";
import PlateNumberDialog from "../../../../../../components/PlateNumberDialog";
import KeyboardIcon from "@mui/icons-material/Keyboard";
import FormFieldSelect from "../../../../../../components/FormFieldSelect";
import {VisitorStatus} from "../../../../../../modules/vms/enums/VisitorStatus";
import {VisitorDriveType} from "../../../../../../modules/vms/enums/VisitorDriveType";

export type VisitorDetailDialogProps = {
    onCancel: () => void;
    onOk: (requestVisitor: RequestVisitorDto) => void;
    open: boolean;
    requestVisitor: RequestVisitorDto;
    visitorIndex: number;
};

const VisitorDetailDialog: React.FC<VisitorDetailDialogProps> = (props) => {
    const intl = useIntl();

    const [messageMap, setMessageMap] = useState(new Map<string, string>());
    const [innerVisitor, setInnerVisitor] = useState<RequestVisitorDto>(props.requestVisitor);
    const [openPlateNumberDialog, setOpenPlateNumberDialog] = useState(false);
    // 访客类型
    const [visitorTypes, setVisitorTypes] = useState(new Array<DictItemDto>());

    useEffect(() => {
        // 查询证件类型字典项
        fetchDictClassList();
    }, []);

    useEffect(() => {
        setInnerVisitor(props.requestVisitor);
    }, [props.requestVisitor]);

    const fetchDictClassList = async () => {
        const codes = new Array<string>(DictClassCode.VMS_VISITOR_TYPE);
        const responseResult = await DictClassApi.getDictClassList(codes);
        if (responseResult.status === HttpStatus.SUCCESS) {
            for (let dictClass of responseResult.data) {
                switch (dictClass.code) {
                    case DictClassCode.VMS_VISITOR_TYPE:
                        setVisitorTypes(dictClass.dictItems);
                        break;
                }
            }
        }
    };

    const handleChange = (name: string, value: any) => {
        setInnerVisitor({...innerVisitor, [name]: value});
    };

    const handleOk = () => {
        if (!validate()) {
            return;
        }
        props.onOk(innerVisitor);
    };

    const handleClose = () => {
        props.onCancel();
    };

    const validate = () => {
        const newMessageMap = new Map<string, string>();
        if (innerVisitor.lastName === '') {
            newMessageMap.set('lastName', intl.formatMessage({id: 'VMS_REQUEST_VISITOR_LAST_NAME_REQUIRED'}));
        }
        if (innerVisitor.firstName === '') {
            newMessageMap.set('firstName', intl.formatMessage({id: 'VMS_REQUEST_VISITOR_FIRST_NAME_REQUIRED'}));
        }
        if (innerVisitor.mobile === '') {
            newMessageMap.set('mobile', intl.formatMessage({id: 'VMS_REQUEST_VISITOR_MOBILE_REQUIRED'}));
        } else if (!ValidateUtils.isMobileNumber(innerVisitor.mobile)) {
            newMessageMap.set('mobile', intl.formatMessage({id: 'VMS_REQUEST_VISITOR_MOBILE_FORMAT_ERROR'}));
        }
        // if (innerVisitor.email && !ValidateUtils.isEmail(innerVisitor.email)) {
        //     newMessageMap.set('email', intl.formatMessage({id: 'COMMON_EMAIL_FORMAT'}));
        // }
        if (innerVisitor.company === '') {
            newMessageMap.set('company', intl.formatMessage({id: 'VMS_REQUEST_VISITOR_COMPANY_REQUIRED'}));
        }

        setMessageMap(newMessageMap);
        return newMessageMap.size <= 0;
    };

    return (
        <Dialog open={props.open} onClose={handleClose} fullWidth={true}>
            <PlateNumberDialog open={openPlateNumberDialog} onOk={(value) => handleChange("plateNumber", value)}
                               onClose={() => setOpenPlateNumberDialog(false)}
                               value={innerVisitor.plateNumber}/>
            <DialogTitle>
                {props.visitorIndex >= 0 ? intl.formatMessage({id: 'VMS_REQUEST_VISITOR_MODIFY'}) : intl.formatMessage({id: 'VMS_REQUEST_VISITOR_CREATE'})}
            </DialogTitle>
            <DialogContent>
                <Grid container columnSpacing={2}>
                    <Grid item xs={6}>
                        <FormFieldText label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_LAST_NAME"})}
                                       placeholder={intl.formatMessage({id: "VMS_REQUEST_VISITOR_LAST_NAME_REQUIRED"})}
                                       required={true} errorText={messageMap.get("lastName")}
                                       value={innerVisitor.lastName}
                                       onChange={(value) => {
                                           handleChange("lastName", value)
                                       }}/>
                    </Grid>
                    <Grid item xs={6}>
                        <FormFieldText label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_FIRST_NAME"})}
                                       placeholder={intl.formatMessage({id: "VMS_REQUEST_VISITOR_FIRST_NAME_REQUIRED"})}
                                       required={true} errorText={messageMap.get("firstName")}
                                       value={innerVisitor.firstName}
                                       onChange={(value) => {
                                           handleChange("firstName", value)
                                       }}/>
                    </Grid>
                    <Grid item xs={6}>
                        <FormFieldText label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_MOBILE"})}
                                       placeholder={intl.formatMessage({id: "VMS_REQUEST_VISITOR_MOBILE_REQUIRED"})}
                                       required={true} errorText={messageMap.get("mobile")}
                                       type={"number"}
                                       value={innerVisitor.mobile}
                                       onChange={(value) => {
                                           handleChange("mobile", value)
                                       }}/>
                    </Grid>
                    {/*<Grid item xs={6}>*/}
                    {/*    <FormFieldText label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_EMAIL"})}*/}
                    {/*                   placeholder={intl.formatMessage({id: "VMS_REQUEST_VISITOR_EMAIL_REQUIRED"})}*/}
                    {/*                   type={"email"}*/}
                    {/*                   errorText={messageMap.get("email")}*/}
                    {/*                   value={innerVisitor.email}*/}
                    {/*                   onChange={(value) => {*/}
                    {/*                       handleChange("email", value)*/}
                    {/*                   }}/>*/}
                    {/*</Grid>*/}
                    <Grid item xs={6}>
                        <FormFieldText label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_COMPANY"})}
                                       placeholder={intl.formatMessage({id: "VMS_REQUEST_VISITOR_COMPANY_REQUIRED"})}
                                       required={true} errorText={messageMap.get("company")}
                                       value={innerVisitor.company}
                                       onChange={(value) => {
                                           handleChange("company", value)
                                       }}/>
                    </Grid>
                    <Grid item xs={6}>
                        <FormFieldSelect label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_DRIVE_TYPE"})}
                                         value={innerVisitor.driveType}
                                         onChange={(value) => {
                                             handleChange("driveType", value)
                                         }}
                                         items={VisitorDriveType.List.map((item) => {
                                             return {label: intl.formatMessage({id: item.label}), value: item.value}
                                         })}/>
                    </Grid>
                    <Grid item xs={6}>
                        <FormFieldText label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_PLATE_NUMBER"})}
                                       placeholder={intl.formatMessage({id: "VMS_REQUEST_VISITOR_PLATE_NUMBER_REQUIRED"})}
                                       value={innerVisitor.plateNumber}
                                       endAdornment={
                                           <IconButton color="primary" onClick={() => setOpenPlateNumberDialog(true)}>
                                               <KeyboardIcon/>
                                           </IconButton>}/>
                    </Grid>
                    <Grid item xs={6}>
                        <FormFieldText label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_ID_NUMBER"})}
                                       placeholder={intl.formatMessage({id: "VMS_REQUEST_VISITOR_ID_NUMBER_REQUIRED"})}
                                       value={innerVisitor.idNumber}
                                       onChange={(value) => {
                                           handleChange("idNumber", value)
                                       }}/>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <CancelButton onClick={handleClose}/>
                <SaveButton onClick={handleOk}/>
            </DialogActions>
        </Dialog>
    );
};

export default VisitorDetailDialog;